export const GENERIC_PROJECT_HORIZONTAL_NAV = 'GENERIC_PROJECT_HORIZONTAL_NAV' as const;
